import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreateImage from "./CreateImage";

const Image: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [activeTab, setActiveTab] = useState<"t2i">("t2i");

  // Update active tab based on URL
  useEffect(() => {
    const path = location.pathname;

    if (path === "/image" || path === "/image/t2i") {
      setActiveTab("t2i");
      if (path === "/image") {
        navigate("/image/t2i", { replace: true });
      }
    }
  }, [location.pathname, navigate]);

  return (
    <div className="flex flex-col h-full bg-black dark:bg-black">
      {/* Tab Navigation */}
      <div className="border-b border-white/10 dark:border-white/10 px-4 sm:px-6 pt-6 pb-0 transition-colors duration-300">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-1.5 md:gap-2">
            <button
              className="relative flex items-center gap-2 px-3 md:px-6 py-2.5 md:py-3 rounded-t-lg text-sm md:text-base font-medium transition-all duration-200 bg-black/60 dark:bg-black/60 text-white dark:text-white"
            >
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                />
              </svg>
              <span className="hidden sm:inline">Text to Image</span>
              <span className="sm:hidden">Text</span>
              <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-white dark:bg-white" />
            </button>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto scrollbar-hide overscroll-none">
        <CreateImage />
      </div>
    </div>
  );
};

export default Image;
